import React from 'react';
import {
  PinIcon,
  SearchIcon,
  RetailIcon,
  OfficeIcon,
  AgentIcon,
} from '@domain-group/fe-co-icon';
import { Avatar } from '@domain-group/fe-blueprint-ui/avatar';
import * as styles from './option.style';
import { Option } from '../types';

const FillAvatar = ({ avatar }: { avatar?: string }): JSX.Element => (
  <span css={styles.iconV5AvatarFill}>
    <Avatar
      shape="square"
      size="custom"
      colorScheme="light"
      imageUrl={avatar}
    />
  </span>
);

export interface OptionIconProps {
  option: Option;
  useTypeaheadV5?: boolean;
}

const OptionIcon = ({
  option: { category, avatar },
  useTypeaheadV5 = false,
}: OptionIconProps): JSX.Element | null => {
  if (!useTypeaheadV5) {
    switch (category) {
      case 'Suburb':
        return <PinIcon />;
      case 'Agent':
        return <Avatar size="small" colorScheme="light" imageUrl={avatar} />;
      case 'Agency':
        return <RetailIcon />;
      default:
        return null;
    }
  }

  switch (category) {
    case 'Suburb':
      return <SearchIcon css={styles.iconV5Location} />;
    case 'Agent':
      return avatar ? <FillAvatar avatar={avatar} /> : <AgentIcon />;
    case 'Agency':
      return avatar ? <FillAvatar avatar={avatar} /> : <OfficeIcon />;
    default:
      return null;
  }
};

export default OptionIcon;
